import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Layout } from 'antd';
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";

const { Header, Content } = Layout;

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes) => {
    let activeRoute = "Main Dashboard";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <Layout style={{ minHeight: '100vh' }} className="bg-lightPrimary dark:!bg-navy-900">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      <Layout style={{ 
        transition: 'all 0.2s ease-in-out',
        marginLeft: window.innerWidth < 1200 ? 0 : (open ? 230 : 0)
       }} className="bg-lightPrimary dark:!bg-navy-900">
        <Header
          style={{
            position: 'fixed',
            zIndex: 40,
            width: '100%',
            padding: 0,
            height: 'auto',
            lineHeight: 'normal',
            backgroundColor: 'transparent',
            right: 0,
            transition: 'all 0.2s ease-in-out',
            // maxWidth: window.innerWidth < 1200 ? '100%' : (open ? 'calc(100% - 234px)' : '100%')
          }}
        >
          <Navbar
            onOpenSidenav={() => setOpen(true)}
            logoText={"OP Chatbot Tailwind React"}
            brandText={currentRoute}
            secondary={getActiveNavbar(routes)}
            {...rest}
          />
        </Header>
        <Content
          style={{
            marginTop: '100px',
            padding: '0 12px',
          }}
          className="h-full flex-none transition-all md:pr-2"
        >
          <div className="mt-3 pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
            <Routes>
              {getRoutes(routes)}

              <Route
                path="/"
                element={<Navigate to="/admin/dashboard" replace />}
              />
            </Routes>
          </div>
          <div className="p-3">
            <Footer />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
